<template>
  <Admin>
    <v-main class="wrapper">
      <el-container>
        <el-main>
          <el-card>
            <div class="ap-automation-summary">
              <!-- Date Range Filter -->
              <el-row :gutter="16" class="filter-row">
                <!-- Start Date -->
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                  <el-date-picker
                    v-model="searchStartDate"
                    type="date"
                    placeholder="เลือกวันที่เริ่มต้น (timeCreate)"
                    clearable
                    style="width: 100%;"
                  />
                </el-col>

                <!-- End Date -->
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                  <el-date-picker
                    v-model="searchEndDate"
                    type="date"
                    placeholder="เลือกวันที่สิ้นสุด (timeCreate)"
                    clearable
                    style="width: 100%;"
                  />
                </el-col>

                <!-- Search Button -->
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                  <el-button
                    type="primary"
                    @click="fetchInvoices"
                    style="margin-top: 4px; width: 100%;"
                  >
                    ค้นหา
                  </el-button>
                </el-col>
              </el-row>

              <!-- Summary Boxes -->
              <el-row :gutter="16" class="summary-boxes" style="margin-top: 20px;">
                <el-col :xs="24" :sm="12" :md="6">
                  <el-card shadow="hover" class="summary-card">
                    <template #header>
                      <strong>จำนวนไฟล์ที่ Upload ทั้งหมด</strong>
                    </template>
                    <div class="summary-value">
                      {{ totalUpload }} ไฟล์
                    </div>
                    <div class="summary-percentage">(100%)</div>
                  </el-card>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-card shadow="hover" class="summary-card">
                    <template #header>
                      <strong>จำนวนไฟล์ที่ Reject ทั้งหมด</strong>
                    </template>
                    <div class="summary-value">
                      {{ totalReject }} ไฟล์
                    </div>
                    <div class="summary-percentage">
                      ({{ totalRejectPct }}%)
                    </div>
                  </el-card>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-card shadow="hover" class="summary-card">
                    <template #header>
                      <strong>จำนวนไฟล์สมบูรณ์</strong>
                      <br />
                      <!-- <small>
                        (PENDING_APPROVAL/APPROVED &amp; ไม่มีการแก้ไข และไม่ Reject)
                      </small> -->
                    </template>
                    <div class="summary-value">
                      {{ totalComplete }} ไฟล์
                    </div>
                    <div class="summary-percentage">
                      ({{ totalCompletePct }}%)
                    </div>
                  </el-card>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-card shadow="hover" class="summary-card">
                    <template #header>
                      <strong>จำนวนไฟล์ที่มีการแก้ไข</strong>
                    </template>
                    <div class="summary-value">
                      {{ totalEdited }} ไฟล์
                    </div>
                    <div class="summary-percentage">
                      ({{ totalEditedPct }}%)
                    </div>
                  </el-card>
                </el-col>
              </el-row>

              <!-- Table: Complete Files -->
              <el-card class="mt-4">
                <template #header>
                  <strong>
                    ไฟล์สมบูรณ์ (PENDING_APPROVAL/APPROVED, ไม่ Reject, ไม่แก้ไข) - {{ completeFiles.length }} ไฟล์
                  </strong>
                </template>

                <div style="overflow-x: auto;">
                  <el-table
                    v-if="completeFiles.length"
                    :data="completeFiles"
                    border
                    style="width: 100%; min-width: 900px;"
                    size="small"
                  >
                  <el-table-column prop="docId" label="เลขที่เอกสาร" />
                    <el-table-column label="วันที่นำเข้า">
                      <template #default="{ row }">
                        {{ formatTimestamp(row.timeCreate) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="cardName" label="ชื่อผู้จำหน่าย" />
                    <el-table-column prop="branchCode" label="รหัสสาขา" />
                    <el-table-column prop="taxId" label="เลขที่ผู้เสียภาษี" />
                    <el-table-column label="วันที่เอกสาร">
                      <template #default="{ row }">
                        {{ formatTimestamp(row.docDate) }}
                      </template>
                    </el-table-column>
                  </el-table>

                  <div v-else style="padding: 1em; text-align: center; color: gray;">
                    ไม่มีข้อมูลไฟล์สมบูรณ์
                  </div>
                </div>
              </el-card>

              <!-- Table: Edited Files with "expand row" for userActivities doc showing only new value -->
              <el-card class="mt-4">
                <template #header>
                  <strong>ไฟล์ที่มีการแก้ไข - {{ editedFiles.length }} ไฟล์ </strong> 
                </template>

                <div style="overflow-x: auto;">
                  <el-table
                    v-if="editedFiles.length"
                    :data="editedFiles"
                    border
                    style="width: 100%; min-width: 1000px;"
                    size="small"
                  >
                    <!-- Expand Column for userActivities -->
                    <el-table-column type="expand">
                      <template #default="{ row }">
                        <!-- Nested table or listing for userActivities doc(s) with eventType=UPDATE -->
                        <div
                          v-for="(act, idx) in row.userActivities.filter(a => a.eventType === 'UPDATE')"
                          :key="idx"
                          class="expanded-activity"
                        >
                          <strong>Activity ID:</strong> {{ act.id }}  
                          <br />
                          <strong>Time:</strong> {{ formatTimestamp(act.timeCreate) }}
                          <br />
                          <strong>Edited Fields:</strong>
                          <el-table
                            :data="getEditsArray(act.eventDetails)"
                            size="mini"
                            border
                            style="margin: 8px 0;"
                          >
                            <el-table-column prop="fieldName" label="Field Name" width="140" />
                            <!-- We only display the newVal -->
                            <el-table-column prop="newVal" label="New Value" />
                          </el-table>
                        </div>
                      </template>
                    </el-table-column>

                    <!-- Basic doc columns -->
                    <el-table-column prop="docId" label="เลขที่เอกสาร" />
                    <el-table-column label="วันที่นำเข้า">
                      <template #default="{ row }">
                        {{ formatTimestamp(row.timeCreate) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="docId" label="เลขที่เอกสาร" />
                    <el-table-column prop="cardName" label="ชื่อผู้จำหน่าย" />
                    <el-table-column prop="branchCode" label="รหัสสาขา" />
                    <el-table-column prop="taxId" label="เลขที่ผู้เสียภาษี" />
                    <el-table-column label="วันที่เอกสาร">
                      <template #default="{ row }">
                        {{ formatTimestamp(row.docDate) }}
                      </template>
                    </el-table-column>
                  </el-table>

                  <div v-else style="padding: 1em; text-align: center; color: gray;">
                    ไม่มีข้อมูลไฟล์แก้ไข
                  </div>
                </div>
              </el-card>
            </div>
          </el-card>
        </el-main>
      </el-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import moment from "moment";

export default {
  name: "ApAutomationCompleteNoEditMultiStatus",
  components: { Admin },
  data() {
    return {
      purchaseInvoices: [],
      searchStartDate: null,
      searchEndDate: null,
      isLoading: false,
      unsubscribe: null,
    };
  },
  computed: {
    // Summaries
    totalUpload() {
      return this.purchaseInvoices.length;
    },
    totalReject() {
      return this.purchaseInvoices.filter((inv) => inv.status === "REJECTED").length;
    },
    totalEdited() {
      return this.purchaseInvoices.filter((inv) =>
        inv.userActivities?.some((a) => a.eventType === "UPDATE")
      ).length;
    },
    totalComplete() {
      return this.purchaseInvoices.filter(
        (inv) =>
          inv.status !== "REJECT" &&
          (inv.status === "PENDING_APPROVAL" || inv.status === "APPROVED") &&
          !inv.userActivities?.some((a) => a.eventType === "UPDATE")
      ).length;
    },

    // Percentages
    totalRejectPct() {
      return this.calcPercentage(this.totalReject);
    },
    totalCompletePct() {
      return this.calcPercentage(this.totalComplete);
    },
    totalEditedPct() {
      return this.calcPercentage(this.totalEdited);
    },

    // Arrays for table display
    completeFiles() {
      return this.purchaseInvoices.filter(
        (inv) =>
          inv.status !== "REJECT" &&
          (inv.status === "PENDING_APPROVAL" || inv.status === "APPROVED") &&
          !inv.userActivities?.some((a) => a.eventType === "UPDATE")
      );
    },
    editedFiles() {
      return this.purchaseInvoices.filter((inv) =>
        inv.userActivities?.some((a) => a.eventType === "UPDATE")
      );
    },
  },
  methods: {
    formatTimestamp(ts) {
      if (!ts?.seconds) return "";
      const d = new Date(ts.seconds * 1000);
      return moment(d).format("DD/MM/YYYY HH:mm:ss");
    },
    calcPercentage(count) {
      if (this.totalUpload === 0) return 0;
      return Math.round((count / this.totalUpload) * 100);
    },

    // Build an array of {fieldName, newVal} from the eventDetails object
    getEditsArray(eventDetails) {
      const edits = [];
      if (!eventDetails) return edits;
      for (const fieldName in eventDetails) {
        const detailObj = eventDetails[fieldName];
        // Only show new value
        const newVal = detailObj?.new ?? "";
        edits.push({
          fieldName,
          newVal: typeof newVal === "object" ? JSON.stringify(newVal) : newVal,
        });
      }
      return edits;
    },

    async fetchInvoices() {
      this.isLoading = true;
      try {
        const companyID = this.$route.params.companyId;
        let query = fc.db.collection(`Companies/${companyID}/PurchaseInvoices`);

        // Filter by timeCreate range
        if (this.searchStartDate) {
          const start = new Date(this.searchStartDate);
          start.setHours(0, 0, 0, 0);

          const end = this.searchEndDate
            ? new Date(this.searchEndDate)
            : new Date(this.searchStartDate);
          end.setHours(23, 59, 59, 999);

          query = query.where("timeCreate", ">=", start);
          query = query.where("timeCreate", "<=", end);
        }

        query = query.orderBy("timeCreate", "desc");

        const snapshot = await query.get();
        let docs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          userActivities: [],
        }));

        if (!docs.length) {
          this.purchaseInvoices = [];
          return;
        }

        // Gather doc IDs
        const invoiceIds = docs.map((d) => d.id);
        const chunkSize = 10;
        let allActivities = [];

        for (let i = 0; i < invoiceIds.length; i += chunkSize) {
          const slice = invoiceIds.slice(i, i + chunkSize);
          const activitiesRef = fc.db.collection(
            `Companies/${companyID}/UserActivities`
          );
          const actSnap = await activitiesRef
            .where("targetDocID", "in", slice)
            .get();

          const chunkActivities = actSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          allActivities = allActivities.concat(chunkActivities);
        }

        // Group userActivities by targetDocID
        const activitiesByDoc = {};
        for (const act of allActivities) {
          const docId = act.targetDocID;
          if (!activitiesByDoc[docId]) {
            activitiesByDoc[docId] = [];
          }
          activitiesByDoc[docId].push(act);
        }

        // Merge back
        docs = docs.map((d) => ({
          ...d,
          userActivities: activitiesByDoc[d.id] || [],
        }));

        this.purchaseInvoices = docs;
      } catch (err) {
        console.error("Error fetching invoices:", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    const companyID = this.$route.params.companyId;
    // Set up realtime listener for PurchaseInvoices
    this.unsubscribe = fc.db
      .collection(`Companies/${companyID}/PurchaseInvoices`)
      .orderBy("timeCreate", "desc")
      .onSnapshot(snapshot => {
        this.purchaseInvoices = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      });
  },
  beforeDestroy() {
    // Clean up the listener when the component is destroyed
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
.ap-automation-summary {
  padding: 16px;
}

.filter-row {
  margin-bottom: 12px;
}

/* Summaries styling */
.summary-boxes {
  margin-top: 20px;
}
.summary-card {
  text-align: center;
  padding: 8px 0;
}



.summary-value {
  font-size: 1.5em;
  margin-top: 6px;
}
.summary-percentage {
  font-size: 1.1em;
  margin-top: 4px;
  color: #666;
}
.mt-4 {
  margin-top: 20px;
}
.no-data {
  margin: 20px 0;
}

/* Just some spacing for each expanded user activity */
.expanded-activity {
  border: 1px solid #ebeef5;
  padding: 8px;
  margin-bottom: 10px;
  background: #fafafa;
  border-radius: 4px;
}
</style>
